/**
 *
 * @module clubProperties
 * @author Greg Babula [greg.babula@mlb.com]
 * @description Properties of MLB clubs
 *
 */

/* global module */

(function(root, factory) {

    if (typeof define === 'function' && define.amd) {
        define('clubProperties/clubProperties',[], factory);
    } else if (typeof exports === 'object') {
        module.exports = factory();
    } else {
        root.bamClubProperties = factory();
    }

}(this, function() {

    'use strict';

    return {
        'ana': {
            'mobile_url_base': 'angels.mlb.com',
            'url_cache': 'losangeles.angels.mlb.com',
            'club_common_url': 'angels.com'
        },
        'ari': {
            'mobile_url_base': 'dbacks.mlb.com',
            'url_cache': 'arizona.diamondbacks.mlb.com',
            'club_common_url': 'dbacks.com'
        },
        'atl': {
            'mobile_url_base': 'braves.mlb.com',
            'url_cache': 'atlanta.braves.mlb.com',
            'club_common_url': 'braves.com'
        },
        'bal': {
            'mobile_url_base': 'orioles.mlb.com',
            'url_cache': 'baltimore.orioles.mlb.com',
            'club_common_url': 'orioles.com'
        },
        'bos': {
            'mobile_url_base': 'redsox.mlb.com',
            'url_cache': 'boston.redsox.mlb.com',
            'club_common_url': 'redsox.com'
        },
        'chc': {
            'mobile_url_base': 'cubs.mlb.com',
            'url_cache': 'chicago.cubs.mlb.com',
            'club_common_url': 'cubs.com'
        },
        'cin': {
            'mobile_url_base': 'reds.mlb.com',
            'url_cache': 'cincinnati.reds.mlb.com',
            'club_common_url': 'reds.com'
        },
        'cle': {
            'mobile_url_base': 'indians.mlb.com',
            'url_cache': 'cleveland.indians.mlb.com',
            'club_common_url': 'indians.com'
        },
        'col': {
            'mobile_url_base': 'rockies.mlb.com',
            'url_cache': 'colorado.rockies.mlb.com',
            'club_common_url': 'Rockies.com'
        },
        'cws': {
            'mobile_url_base': 'whitesox.mlb.com',
            'url_cache': 'chicago.whitesox.mlb.com',
            'club_common_url': 'whitesox.com'
        },
        'det': {
            'mobile_url_base': 'tigers.mlb.com',
            'url_cache': 'detroit.tigers.mlb.com',
            'club_common_url': 'tigers.com'
        },
        'hou': {
            'mobile_url_base': 'astros.mlb.com',
            'url_cache': 'houston.astros.mlb.com',
            'club_common_url': 'astros.com'
        },
        'kc': {
            'mobile_url_base': 'royals.mlb.com',
            'url_cache': 'kansascity.royals.mlb.com',
            'club_common_url': 'royals.com'
        },
        'la': {
            'mobile_url_base': 'dodgers.mlb.com',
            'url_cache': 'losangeles.dodgers.mlb.com',
            'club_common_url':'dodgers.com'
        },
        'mia': {
            'mobile_url_base':'marlins.mlb.com',
            'url_cache':'miami.marlins.mlb.com',
            'club_common_url': 'marlins.com'
        },
        'mil': {
            'mobile_url_base': 'brewers.mlb.com',
            'url_cache': 'milwaukee.brewers.mlb.com',
            'club_common_url': 'brewers.com'
        },
        'min': {
            'mobile_url_base': 'twins.mlb.com',
            'url_cache': 'minnesota.twins.mlb.com',
            'club_common_url': 'twinsbaseball.com'
        },
        'mlb': {
            'mobile_url_base': 'mlb.com',
            'url_cache': 'mlb.mlb.com',
            'club_common_url': 'MLB.com'
        },
        'nym': {
            'mobile_url_base': 'mets.mlb.com',
            'url_cache': 'newyork.mets.mlb.com',
            'club_common_url': 'mets.com'
        },
        'nyy': {
            'mobile_url_base': 'yankees.mlb.com',
            'url_cache': 'newyork.yankees.mlb.com',
            'club_common_url': 'yankees.com'
        },
        'oak': {
            'mobile_url_base': 'athletics.mlb.com',
            'url_cache': 'oakland.athletics.mlb.com',
            'club_common_url': 'athletics.com'
        },
        'phi': {
            'mobile_url_base': 'phillies.mlb.com',
            'url_cache': 'philadelphia.phillies.mlb.com',
            'club_common_url': 'phillies.com'
        },
        'pit': {
            'mobile_url_base': 'pirates.mlb.com',
            'url_cache': 'pittsburgh.pirates.mlb.com',
            'club_common_url': 'pirates.com'
        },
        'sd': {
            'mobile_url_base': 'padres.mlb.com',
            'url_cache': 'sandiego.padres.mlb.com',
            'club_common_url': 'padres.com'
        },
        'sea': {
            'mobile_url_base': 'mariners.mlb.com',
            'url_cache': 'seattle.mariners.mlb.com',
            'club_common_url': 'Mariners.com'
        },
        'sf': {
            'mobile_url_base': 'giants.mlb.com',
            'url_cache': 'sanfrancisco.giants.mlb.com',
            'club_common_url': 'SFGiants.com'
        },
        'stl': {
            'mobile_url_base': 'cardinals.mlb.com',
            'url_cache': 'stlouis.cardinals.mlb.com',
            'club_common_url': 'cardinals.com'
        },
        'tb': {
            'mobile_url_base': 'rays.mlb.com',
            'url_cache': 'tampabay.rays.mlb.com',
            'club_common_url': 'raysbaseball.com'
        },
        'tex': {
            'mobile_url_base': 'rangers.mlb.com',
            'url_cache': 'texas.rangers.mlb.com',
            'club_common_url': 'texasrangers.com'
        },
        'tor': {
            'mobile_url_base': 'bluejays.mlb.com',
            'url_cache': 'toronto.bluejays.mlb.com',
            'club_common_url': 'bluejays.com'
        },
        'was': {
            'mobile_url_base': 'nationals.mlb.com',
            'url_cache': 'washington.nationals.mlb.com',
            'club_common_url': 'nationals.com'
        }
    };

}));

